import PropTypes from 'prop-types'
import { Select, SIZE } from 'baseui/select'
import { mergeOverrides } from 'baseui'
import { SDSelectOverrides } from './styled-components'

const SDSelect = ({ overrides, dataTestid, ...rest }) => {
  const newOverrides = mergeOverrides(SDSelectOverrides(), overrides)
  const { id } = rest
  return (
    <Select
      {...rest}
      id={dataTestid || id}
      maxDropdownHeight='320px'
      labelKey='label'
      valueKey='label'
      size={SIZE.compact}
      overrides={newOverrides}
    />
  )
}

SDSelect.propTypes = {
  overrides: PropTypes.object,
  dataTestid: PropTypes.string,
}

export default SDSelect
